import React, { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Row, Col, Button } from 'reactstrap';
import { useParams, useNavigate, Link } from "react-router-dom";
import CompLoaderBtn from '../Common/CompLoaderBtn';
import CompLoaderDt from '../Common/CompLoaderDt';
function CompDtCrmAddressInformation() {
    const { t } = useTranslation();
    const params = useParams();
    let crmId = params.crmId;

    const [componentId] = useState('compDtCashDesk');
    const [data, setData] = useState(null);

    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const [modalCreateCashDesk, setModalCreateCashDesk] = useState(false);
    const toggleModalCreateCashDesk = () => setModalCreateCashDesk(!modalCreateCashDesk);

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (crmId && crmId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/market-place/trader/crm-contact/crm/' + crmId + '/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            setData(response.data?.payload);
                        }

                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, crmId, pageNumber, pageSize, sort]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-address-information.dt.th.record-name')}</span>,
            selector: row => <span title={row?.recordName}>{row?.recordName}</span>,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-address-information.dt.th.contact-type')}</span>,
            selector: row => <span title={row?.contactType?.label}>{row?.contactType?.label}</span>,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'></span>,
            selector: row => <Button disabled={apiCalled} color="dark" className={row?.contactType?.value === 'ACCOUNT_OWNER' ? "d-none" : "btn-load w-sm me-1"} outline onClick={(e) => callChangePasswordApi()}>
                <span className={apiCalled === true && apiCalledBy === 'ChangePassword' ? "d-flex align-items-center" : "d-none"}>
                    <div className="flex-shrink-0">
                        <CompLoaderBtn />
                    </div>
                    <span className="flex-grow-1 ms-2">
                        {t('product.common-button.please-wait')}
                    </span>
                </span>
                {apiCalled === false || apiCalledBy !== 'Edit' ? <span><i className="align-bottom me-1" ></i>{t('components.crm.comp-dt-address-information.dt.td.button.show')}</span> : ''}
            </Button>,
            sortable: false,
            maxWidth: "225px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.page?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    const callChangePasswordApi = () => {
        setApiCalledBy('ChangePassword');
        setApiCalled(true);
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            let apiRequestBody = ({

            });
            axios.post(ApiGateway + '/market-place/trader/my-crm-contact/test/', apiRequestBody)
                .then(response => {
                    setApiCalled(false);
                    if (response.data?.isSucceed === true) {

                    } else {
                        response.data?.messages?.forEach((item) => {
                            let message = item.message;
                            toast.error(message, { autoClose: 500 });
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                    setApiCalled(false);
                });
        }
    }

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtCrmAddressInformation;